import { Tiles } from './ListTiles.style';

type tListTiles = {
  children: JSX.Element | JSX.Element[];
};

const ListTiles: React.FC<tListTiles> = ({ children }): JSX.Element => <Tiles>{children}</Tiles>;

export default ListTiles;
